// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__Tkk4-","consentsList":"PatientConsents_consentsList__3Rbtv","consentsListEmpty":"PatientConsents_consentsListEmpty__2RG0-"};